/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentAvatarSingleUserPickerNINRelayProvider = {
	get(): boolean {
		return fg('jira_ai_agent_avatar_single_user_picker_nin');
	},
};

export default JiraAiAgentAvatarSingleUserPickerNINRelayProvider;
